<template>
  <h1>Coming soon</h1>
</template>
<script>
export default {
  name: 'ComingSoon',
}
</script>